<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordocas/svgCas39bg.svg" />
    <img id="cloud" class="pageElement slideItem" src="/pages/img/sordocas/svgCas39Cloud.svg" />

    <span class="normalTheme pageInstruction" style="left: 65px; top: 118px">
      <p>Lee con atención este texto.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 65px; top: 180px">
      <p>Tacha las palabras que esten repetidas</p>
    </span>

    <p
      class="textBase appearAnimationB"
      id="crossingText"
      style="z-index: 6"
      ref="crossingText"
    >
      "Los castillos estaban rodeados por una alta muralla. Los castillos
      también estaban rodeados por un gran foso con o sin agua. para cruzar el
      foso del castillo fue necesario construir puentes. Algunos puentes eran de
      piedra y otros eran levadizos."
    </p>

    <span class="normalTheme pageInstruction" style="left: 65px; top: 530px">
      <p>
        Entre todos escriban el texto en el pizarrón, dictándole al maestro.
      </p>
    </span>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 50px;
  top: 499px;
}
#cloud {
  position: absolute;
  left: 628px;
  top: 606px;
}
#crossingText {
  position: absolute;
  width: 889px;
  height: 248px;
  left: 95px;
  top: 247px;
  font-size: 30px;
  line-height: 45px;
  text-transform: uppercase;
  color: #2bb673;
  cursor: default;
}
</style>
<script>
export default {
  methods: {
    dbId(name, option) {
      return `${this.$parent.type}-${this.$parent.page}-${name}-${option}`;
    },
    async loadOption(name, option) {
      var id = this.dbId(name, option);

      var value = await this.$db.options
        .get({
          id: id,
        })
        .catch(function (error) {
          console.log("error getting option" + error);
        });
      if (value === undefined) return;
      console.log(value);

      if (value.option) {
        this.crossWord(option);
      }

      console.log("option loaded: " + id + ", " + value.option);
    },
    saveOption(name, option) {
      var id = this.dbId(name, option);

      var word = document.getElementById(option);
      var c = " highlight";

      var value = word.className.includes(c);

      this.$db.options
        .put({
          id: id,
          option: value,
        })
        .catch(function (error) {
          console.log("error saving option" + error);
        });

      console.log("option saved: " + id + ", " + value);
    },
    setupCrossText(t) {
      var words = t.innerHTML.split(" ");
      this.$refs["crossingText"].innerHTML = "";
      for (var i = 0; i < words.length; i++) {
        this.$refs["crossingText"].innerHTML +=
          '<span class="crossable" id="crt' +
          i +
          '">' +
          words[i] +
          "</span>" +
          " ";
        console.log(words[i]);
      }
      document.querySelectorAll(".crossable").forEach((item) => {
        item.addEventListener("click", () => {
          this.crossWord(item.id);
          this.saveOption("crossingText", item.id);
        });
      });
    },
    crossWord(id) {
      var word = document.getElementById(id);
      var c = " highlight";
      if (word.className.includes(c)) {
        word.className = word.className.replace(c, "");
      } else {
        word.className += c;
      }
    },
  },
  mounted() {
    this.setupCrossText(this.$refs["crossingText"]);
    document.querySelectorAll(".crossable").forEach((item) => {
      this.loadOption("crossingText", item.id);
    });
  },
};
</script>